import { render, staticRenderFns } from "./CoachCommentPage.vue?vue&type=template&id=0445ba04"
import script from "./CoachCommentPage.vue?vue&type=script&lang=js"
export * from "./CoachCommentPage.vue?vue&type=script&lang=js"
import style0 from "./CoachCommentPage.vue?vue&type=style&index=0&id=0445ba04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports